import BaseComponent from "../../../../base/BaseComponent";
import {Input, Table,message} from "antd";
import UpLoad from "../clue/components/upload";
import moment from "moment";
import React from "react";
import request from "../../../../base/request"
import {formatDate} from "../../../../utils";
import Btn from "../../components/btn/Btn";

export default class SolicitationDetails extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            checkedReceive:false,
            checkedRefuse : false,
            arrangementCon:{
        },
            dataSource: [
                {
                    key: '1',
                    name: '胡彦斌',
                    age: 32,
                    address: '西湖区湖底公园1号',
                },
                {
                    key: '2',
                    name: '胡彦祖',
                    age: 42,
                    address: '西湖区湖底公园1号',
                },
            ],
        }
    };
    sysConfigLoadOver(){
        let  sysConfig=this.sysConfig.showRefresh;
        if(sysConfig){
            this.getList()
        }
    }
    onOk() {
        let {
            receiveRequestUrl = '/cm-sites-business/bd/busAppointmentReceiver/update/',
            receiveRequestMethod='post',
            receiveContentType = 'json',
            receiveRequestTextAreaMarkParam = 'mark',
            receiveCustomRequestId = 'id',
            dateParam='replyDate',
            receiveCustomRequestParam='status',
            receiveCustomRequestValue = '已领取',
            receiveApprovalTimeKey='receiveDate',

            refuseRequestUrl = '/cm-sites-business/bd/busAppointmentReceiver/update/',
            refuseRequestMethod='post',
            refuseContentType = 'json',
            refuseCustomRequestId = 'id',
            refuseCustomRequestParam='status',
            refuseCustomRequestValue='已拒绝',
            refuseApprovalTimeKey = 'reviewDate',
            refuseApprovalReasonKey='refuseReason',

        } = this.sysConfig;
        let { checkedReceive,checkedRefuse} = this.state;
        if(!checkedReceive && !checkedRefuse) {
            // message.warning('请选择领取或拒绝')
        }else if(checkedReceive) { // 领取
            let body = {};
            let url = receiveRequestUrl;
            // console.log(receiveRequestMethod)
            url += this.props.record && this.props.record.id;
            body[receiveCustomRequestParam] = receiveCustomRequestValue;
            body[receiveApprovalTimeKey] = new Date().getTime();
            request({url,receiveRequestMethod,
                receiveContentType,body,callBack:()=>{
                }})
        }else {    // 拒绝

        }

    }
    getList(){
        let body = {};

        let requestInformation = this.sysConfig.requestInformation || ""
        let listUrl = requestInformation.listUrl  || "";
        let customRequestId = requestInformation.customRequestId || '';
        if(customRequestId&&this.props.record){
            listUrl=listUrl+this.props.record.appointmentId;
        }
        let requestMethod = requestInformation.requestMethod  || "post";
        let storyTypeKey = requestInformation.requestShowRefKey  || "showRef";
        let storyTypeVal = requestInformation.requestKeywordRefVal  ;

        body[storyTypeKey] = storyTypeVal;
        request({url:listUrl, contentType:"json", body,  method:requestMethod, callBack:(data)=>{
              this.setState({arrangementCon:data},()=>{

              })
            }});
    }


    customRender() {
        let {
            operation = 'details',

            replyDateKey = "要求回稿时间",
            replyDateShow=false,
            replyDateRequired=true,
            replyDateParam= "replyDate",
            replyDatePlaceholder="请输入标题",

            replyContentShow=false,
            replyContentKey="稿件要求",
            replyContentRequired=true,
            replyContentParam="requireContent",
            replyContentPlaceholder= "请输入",

            depthParam = "appointmentObj",

            createTimeShow=false,
            createTimeKey="创建时间",
            createTimeRequired=true,
            createTimeParam= "createTime",
            createTimePlaceholder="请输入电话号码",

            objectShow=false,
            objectKey="约稿对象",
            objectRequired=true,
            objectParam= "contactsWay",
            objectPlaceholder="请选择",

            showReceiveBtn = false,
            receiveBtnText = "领取",
            showRefuseBtn = false,
            refuseBtnText = "拒绝",

            publishMediaShow = false,
            publishMediaKey= "发布媒体",
            publishMediaRequired = true,
            publishMediaParam = 'media',

            releasePerSonShow = false,
            releasePerSonKey = '发行者',
            releasePerSonRequired = true,
            releasePerSonParam = 'releasePerSon'
        } = this.sysConfig;
        let {arrangementCon,checkedReceive,checkedRefuse} = this.state;


        const btnStyle = {
            width: "74px",
            height: "32px",
            // background: "rgba(255, 255, 255, 0.39)",
            border: "1px solid rgba(0, 0, 0, 0.14901960784313725)",
            borderRadius:"3px",
            textAlign:"center",
            lineHeight:"32px",
            cursor:"pointer"
        };

        let columns =this.sysConfig.columns||[];
        let newColumns=[];


        let btnList = this.sysConfig.btnList||[];
        let showRefresh =this.sysConfig.showRefresh;
        let record = this.props.record || "";
        if(record && showRefresh ===false){
            this.state.arrangementCon =record
        }
        let data = this.state.arrangementCon.receiverObjs;
        let statusColor = this.sysConfig.statusColor||{};
        columns&&columns.length&&columns.forEach((item,index)=>{

          if(item.key==='createTime' ) {
                newColumns.push({
                    title: item.title,
                    key: item.key,
                    render: (text, record, index) => {
                        return (
                            <div>{formatDate(record.createTime)}</div>
                        )
                    }
                })
            }else if(item.key==="receiverDepts"){
              newColumns.push({
                  title: item.title,
                  key: item.key,
                  render: (text, record, index) => {
                      let data = record.receiver&&record.receiver.depts;
                    let newData=[];
                      data.forEach((item)=>{
                          newData.push(item.name)
                      });
                      return (<div>{newData.join(',')}</div>)
                  }
              })
          }
          else if(item.key==="btnList"){
                newColumns.push({
                    title: item.title,
                    key: item.key,
                    render: (text, record, index) => {
                        return (<div>
                                <Btn btnList={btnList} currentState={this.state} record={record}
                                     refresh={() => this.refresh()}/>
                            </div>
                        )
                    }
                })
            }
          else if(item.key==="status"){
              newColumns.push({
                  title: item.title,
                  key: item.key,
                  dataIndex: item.key,
                  render: (text, record, index) => {
                      let color ;
                      statusColor&&statusColor.forEach((item)=>{
                          if(item.statusName ===text){
                              color = item.color
                          }
                      });
                      return (
                          <div><span style={{width:'8px',height:'8px',borderRadius:'50%',background:color,display: "inline-block",marginRight:'8px'}}></span><span>{text}</span></div>
                      )
                  }
              })
          }
            else{
                newColumns.push(item)
            }
        })

        return (
            <div>
                {/*以下为约稿详情*/}
                <div style={{display:"flex",justifyContent:"center"}}>
                    {/*{showReceiveBtn && <div style={{...btnStyle,background:checkedReceive?"rgba(255, 255, 255, 0.39) url('images/selected.png') no-repeat center center":""}} onClick={()=>{*/}
                    {/*    this.setState({checkedReceive:true,checkedRefuse:false})*/}
                    {/*}}>{receiveBtnText}</div>}*/}
                    {/*{showRefuseBtn && <div style={{...btnStyle,marginLeft:24,background:checkedRefuse?"rgba(255, 255, 255, 0.39) url('images/selected.png') no-repeat center center":""}} onClick={()=>{*/}
                    {/*    this.setState({checkedReceive:false,checkedRefuse:true})*/}
                    {/*}}>{refuseBtnText}</div>}*/}
                </div>
                {replyDateShow&& <div style={{display:'flex',marginTop:'20px'}}>
                    <div style={{marginRight:'5px',display: 'flex', alignItems: 'center'}}>{replyDateRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{replyDateKey}:</div>
                    <div  style={{ }}>
                        {operation==='details'?<div  style={{ width:'100%' }}> {arrangementCon&&moment(arrangementCon && arrangementCon[depthParam] && arrangementCon[depthParam] [replyDateParam]).format('YYYY-MM-DD HH:mm:ss') }</div>:<Input placeholder={ replyDatePlaceholder }  value={arrangementCon&&arrangementCon.replyDate}
                                                                                                                                                                onChange={(e) => {
                                                                                                                                                                    this.onChange('replyDate', e.target.value)
                                                                                                                                                                }}/>}
                    </div>
                </div>}
                {replyContentShow&& <div style={{display:'flex',marginTop:'20px'}}>
                    <div style={{marginRight:'5px',display: 'flex', alignItems: 'center'}}>{replyContentRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{replyContentKey}:</div>
                    <div  style={{ }}>
                        {operation==='details'?<div  style={{ width:'100%' }}> {arrangementCon && arrangementCon[replyContentParam] && arrangementCon[replyContentParam]}</div>:<Input placeholder={ replyContentPlaceholder }  value={arrangementCon&&arrangementCon.replyDate}
                                                                                                                            onChange={(e) => {
                                                                                                                                this.onChange('replyDate', e.target.value)
                                                                                                                            }}/>}
                    </div>
                </div>}
                {createTimeShow&& <div style={{display:'flex',marginTop:'20px'}}>
                    <div style={{marginRight:'5px',display: 'flex', alignItems: 'center'}}>{createTimeRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{createTimeKey}:</div>
                    <div  style={{ }}>
                        {operation==='details'?<div  style={{ width:'100%' }}> {arrangementCon&&moment(arrangementCon[createTimeParam]).format('YYYY-MM-DD HH:mm:ss') }</div>:<Input placeholder={ createTimePlaceholder }  value={arrangementCon&&arrangementCon.replyDate}
                                                                                                                                                                 onChange={(e) => {
                                                                                                                                                                     this.onChange('replyDate', e.target.value)
                                                                                                                                                                 }}/>}
                    </div>
                </div>}
                {objectShow?<div style={{display:'flex',marginTop:"15px"}}>
                    <div style={{marginRight:'5px',width:'100px',}}>{objectRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{objectKey}</div>
                    <div style={{ flex:"1",}}>
                        <Table columns={newColumns} dataSource={data} pagination={false} />
                    </div>
                </div>:null}
                {
                    publishMediaShow?(<div style={{display:'flex',marginTop:"15px"}}>
                        <div style={{marginRight:'5px',display: 'flex', alignItems: 'center'}}>{publishMediaRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{publishMediaKey}:</div>
                        <div  style={{ }}>
                            {operation==='details'?<div  style={{ width:'100%' }}> {arrangementCon && arrangementCon[depthParam] && arrangementCon[depthParam] [publishMediaParam] }</div>:<Input placeholder={ createTimePlaceholder }  value={arrangementCon&&arrangementCon.replyDate}
                                                                                                                                                                     onChange={(e) => {
                                                                                                                                                                         this.onChange('replyDate', e.target.value)
                                                                                                                                                                     }}/>}
                        </div>
                    </div>):null
                }
                {
                    releasePerSonShow?(<div style={{display:'flex',marginTop:"15px"}}>
                        <div style={{marginRight:'5px',display: 'flex', alignItems: 'center'}}>{releasePerSonRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{releasePerSonKey}:</div>
                        <div  style={{ }}>
                            {operation==='details'?<div  style={{ width:'100%' }}> {arrangementCon&&arrangementCon[depthParam] && arrangementCon[depthParam][releasePerSonParam] }</div>:<Input placeholder={ createTimePlaceholder }  value={arrangementCon&&arrangementCon.replyDate}
                                                                                                                                                                     onChange={(e) => {
                                                                                                                                                                         this.onChange('replyDate', e.target.value)
                                                                                                                                                                     }}/>}
                        </div>
                    </div>):null
                }
            </div>
        )
    }

}